module.exports = __webpack_public_path__ + "img/2.55e17e27.png";